import React, {useEffect, useRef, useState} from 'react';
import {getPersonalBook} from "../../../api/requests";
import styles from "./book.module.scss";
import useTranslation from "next-translate/useTranslation";
// import ReactToPrint from "react-to-print";
import {useReactToPrint} from 'react-to-print';

const MyWordsBook = ({userInfo, fromHome}) => {
    const [showButton, setShowButton] = useState(false)
    const {t, lang} = useTranslation()
    const isRTL = lang === 'farsi';
    const pdfref = useRef();
    const [loading, setLoading] = useState(false);


    const [myBook, setMyBook] = useState()
    // useEffect(() => {
    //     let token = localStorage.getItem('token');
    //     getPersonalBook(token).then(res => {
    //         console.log("personal book res test update", res.data)
    //
    //         setMyBook(res.data)
    //     }).catch(err => console.log('personal user error', err))
    //     // }
    // }, [])
    const memorizedWords = () => {
        const pages = [];
        for (let i = 0; i < Math.ceil(myBook?.words?.memorized.length / 10); i++) {
            pages.push(
                <>
                    <div className="pagebreak"/>
                    <div className={i % 2 !== 0 ? styles.topImage : styles.memorizedRightPage} key={i}>
                        <p className={i % 2 !== 0 ? styles.pageNumber : styles.pageNumberRight}>{i + 1}</p>
                        <table className={i % 2 !== 0 ? styles.table : styles.tableRight}>
                            <tr>
                                <th className={styles.tableHeader}>Word</th>
                                <th className={styles.tableHeader}>Book</th>
                                <th className={styles.tableHeader}>Translation</th>
                            </tr>
                            {
                                myBook?.words?.memorized.slice(i * 10, (i + 1) * 10).map(item => {
                                        return (
                                            <>
                                                <tr>
                                                    <td className={styles.TRword}>{item.Word}</td>
                                                    <td className={styles.TRword}>{item.BookName}</td>
                                                    <td className={`${styles.TRword} ${styles.farsi} ${item.Translation.length > 20 ? styles.smallFont : styles.farsiFontSize}`}>{item.Translation}</td>
                                                </tr>
                                                <tr className={styles.TRsentence}>
                                                    <td colSpan="3">
                                                        {item.ExampleSentence}
                                                    </td>
                                                </tr>
                                                <tr className={`${styles.TRsentence} ${styles.farsi} ${styles.farsiFontSize}`}>
                                                    <td colSpan="3">
                                                        {item.TranslationOfExampleSentence}
                                                    </td>
                                                </tr>
                                            </>
                                        )
                                    }
                                )
                            }
                        </table>
                    </div>
                </>
            );
        }

        return pages;
    };
    const slipperyWords = () => {
        const pages = [];
        for (let i = 0; i < Math.ceil(myBook?.words?.slipper.length / 10); i++) {
            pages.push(
                <>
                    <div className="pagebreak"/>
                    <div className={i % 2 !== 0 ? styles.slipperyWordsPage : styles.slipperyWordsPageRight} key={i}>
                        <p className={i % 2 !== 0 ? styles.pageNumber : styles.pageNumberRight}>{i + 1}</p>
                        <table className={i % 2 !== 0 ? styles.slipperyTable : styles.slipperyTableRight}>
                            <tr>
                                <th className={styles.slipperyTableHeader}>Word</th>
                                <th className={styles.slipperyTableHeader}>Book</th>
                                <th className={styles.slipperyTableHeader}>Translation</th>
                            </tr>
                            {
                                myBook?.words?.slipper.slice(i * 10, (i + 1) * 10).map(item => {
                                        return (
                                            <>
                                                <tr>
                                                    <td className={styles.TRslipperyWord}>{item.Word}</td>
                                                    <td className={styles.TRslipperyWord}>{item.BookName}</td>
                                                    <td className={`${styles.TRslipperyWord} ${styles.farsi} ${item.Translation.length > 20 ? styles.smallFont : styles.farsiFontSize}`}>{item.Translation}</td>
                                                </tr>
                                                <tr className={styles.TRsentence}>
                                                    <td colSpan="3">
                                                        {item.ExampleSentence}
                                                    </td>
                                                </tr>
                                                <tr className={`${styles.TRsentence} ${styles.farsi} ${styles.farsiFontSize}`}>
                                                    <td colSpan="3">
                                                        {item.TranslationOfExampleSentence}
                                                    </td>
                                                </tr>
                                            </>
                                        )
                                    }
                                )
                            }
                        </table>
                    </div>
                </>
            );
        }

        return pages;
    };
    const newWords = () => {
        const pages = [];
        for (let i = 0; i < Math.ceil(myBook?.words?.new.length / 10); i++) {
            pages.push(
                <>
                    <div className="pagebreak"/>
                    <div className={i % 2 !== 0 ? styles.newWordsPage : styles.newWordsPageRight} key={i}>
                        <p className={i % 2 !== 0 ? styles.pageNumber : styles.pageNumberRight}>{i + 1}</p>
                        <table className={i % 2 !== 0 ? styles.slipperyTable : styles.slipperyTableRight}>
                            <tr>
                                <th className={styles.newTableHeader}>Word</th>
                                <th className={styles.newTableHeader}>Book</th>
                                <th className={styles.newTableHeader}>Translation</th>
                            </tr>
                            {
                                myBook?.words?.new.slice(i * 10, (i + 1) * 10).map(item => {
                                        return (
                                            <>
                                                <tr>
                                                    <td className={styles.TRnewWord}>{item.Word}</td>
                                                    <td className={styles.TRnewWord}>{item.BookName}</td>
                                                    <td className={`${styles.TRnewWord} ${styles.farsi} ${item.Translation.length > 20 ? styles.smallFont : styles.farsiFontSize}`}>{item.Translation}</td>
                                                </tr>
                                                <tr className={styles.TRsentence}>
                                                    <td colSpan="3">
                                                        {item.ExampleSentence}
                                                    </td>
                                                </tr>
                                                <tr className={`${styles.TRsentence} ${styles.farsi} ${styles.farsiFontSize}`}>
                                                    <td colSpan="3">
                                                        {item.TranslationOfExampleSentence}
                                                    </td>
                                                </tr>
                                            </>
                                        )
                                    }
                                )
                            }
                        </table>
                    </div>
                </>
            );
        }

        return pages;
    };


    // const printDocument = async () => {
    //     console.log('1111111')
    //
    //     setLoading(true)
    //     const input = document.getElementById("book");
    //     const inputHeight = input.offsetHeight;
    //
    //     var doc = new jsPDF('p', 'mm');
    //     const times = Math.ceil(inputHeight / 31444)
    //     console.log('times', times)
    //
    //     for (let threePages = 0; threePages < times; threePages++) {
    //         console.log("threePages", threePages);
    //         const canv = await html2canvas(input, {
    //             height: 31444, width: 794, y: threePages * 31444,
    //         });
    //         const imgData = canv.toDataURL("image/png");
    //         // console.log(canvas, imgData);
    //         var imgWidth = 210;
    //         var pageHeight = 296.90;
    //         // var pageHeight = 297;
    //
    //
    //         // var pageHeight = 297;
    //         let imgHeight = canv.height * imgWidth / canv.width;
    //         let heightLeft = imgHeight;
    //
    //         let position = 0;
    //
    //         doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight, '', 'FAST');
    //         heightLeft -= pageHeight;
    //
    //         while (heightLeft >= 0) {
    //             position = heightLeft - imgHeight;
    //             doc.addPage();
    //             doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight, '', 'FAST');
    //             heightLeft -= pageHeight;
    //
    //         }
    //
    //     }
    //
    //     doc.save('MyWordBox.pdf');
    //     //
    //     // toBlob(input)
    //     //     .then(function (blob) {
    //     //         const file = new File([blob], "my-node.pdf");
    //     //         console.log('aaaaaaa',file)
    //     //
    //     //         // window.saveAs(blob, 'my-node.png');
    //     //     });
    //
    //     //
    //     // console.log('22222222')
    //     //
    //     // toSvg(input, { quality: 0.5 })
    //     //     .then((dataUrl) => {
    //     //         console.log('333333',dataUrl)
    //     // var link = document.createElement('a');
    //     // link.download = 'myWordBox.svg';
    //     // link.href = dataUrl;
    //     // link.click();
    //     // const doc = new PDFDocument();
    //     // const document = new PDFDocument({
    //     //     layout:"portrait",
    //     //     size:"A4"
    //     // });
    //
    //     // let imgWidth = 210;
    //     //     let pageHeight = 296.90;
    //     //     // let imgHeight = canvas.height * imgWidth / canvas.width;
    //     //     let imgHeight = document.getElementById('book').style.height
    //     //     let heightLeft = imgHeight;
    //     //
    //     //     let doc = new jsPDF('p', 'mm');
    //     //     let position = 0;
    //     //
    //     //     // doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight, '', 'FAST');
    //     //     doc.addSvgAsImage(dataUrl, 0, position, imgWidth, imgHeight, '', 'FAST')
    //     //     heightLeft -= pageHeight;
    //     //
    //     // console.log("44444")
    //     //
    //     //     while (heightLeft >= 0) {
    //     //         position = heightLeft - imgHeight;
    //     //         doc.addPage();
    //     //         // doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight, '', 'FAST');
    //     //         doc.addSvgAsImage(dataUrl, 0, position, imgWidth, imgHeight, '', 'FAST')
    //     //         heightLeft -= pageHeight;
    //     //
    //     //     }
    //     //     doc.save('MyWordBox.pdf');
    //     //     setLoading(false);
    //
    //     //
    //     //         SVGtoPDF(document, dataUrl)
    //     //     })
    //     //     .catch((err) => {
    //     //         console.log(err)
    //     //     })
    //
    //     // html2canvas(input).then(canvas => {
    //     //     const imgData = canvas.toDataURL("image/png");
    //     //
    //     //     console.log("imgData",imgData)
    //     //     let imgWidth = 210;
    //     //     let pageHeight = 296.90;
    //     //     // var pageHeight = 297;
    //     //     let imgHeight = canvas.height * imgWidth / canvas.width;
    //     //     let heightLeft = imgHeight;
    //     //
    //     //     let doc = new jsPDF('p', 'mm');
    //     //     let position = 0;
    //     //
    //     //     doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight, '', 'FAST');
    //     //     heightLeft -= pageHeight;
    //     //
    //     //     while (heightLeft >= 0) {
    //     //         position = heightLeft - imgHeight;
    //     //         doc.addPage();
    //     //         doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight, '', 'FAST');
    //     //         heightLeft -= pageHeight;
    //     //
    //     //     }
    //     //     doc.save('MyWordBox.pdf');
    //     //     setLoading(false);
    //     // }).catch(err => {
    //     //     console.log('js pdf', err);
    //     //     setLoading(false);
    //     // });
    // };

    const getProfileImageSrc = () => {
        // console.log("myBook?.profile?.ProfileImage", myBook?.profile?.ProfileImage)
        // if (myBook?.profile?.ProfileImage.trim()) {
        //     return myBook.profile.ProfileImage
        // } else {
        return '/images/table/profile.png'
        // }
    }

    const handlePrint = useReactToPrint({
        content: () => pdfref.current,
        documentTitle: 'MyWordBox',
        onAfterPrint: () => setLoading(false),
    });

    return (
        <div>
            <a href={`/profile/myWordsBox`} target="_blank">
                <button
                    className={`
                    ${styles.downloadBtnWrapper}
                    ${fromHome ? styles.homeButton : styles.profileButton}
                    ${isRTL ? styles.justify : styles.noJustify}
                    ${fromHome ? (isRTL ? styles.showRTL : styles.showLTR) : ''}
                `}
                    style={{
                        borderRadius: '15px',
                        padding: fromHome ? '0 10px 0' : (isRTL ? '0 40px 0 32px' : '0 10px 0 39px')
                        }}
                        // onClick={loading ? null : printDocument}
                        onClick={() => {
                            // setLoading(true);
                            // handlePrint();
                        }}
                    >
                        {loading ?
                            <div className="spinner-border text-light" role="status">
                                <span className="sr-only">Loading...</span>
                            </div>
                            :
                            (isRTL ? <span><span
                                    style={{fontWeight: 'bold'}}>صندوقچه واژگان</span> خود را دانلود کنید</span> :
                                <div>Download
                                    <div className={styles.letterSpacing}>My Word Box</div>
                                </div>)
                        }
                    {fromHome ? '' :
                        <img
                            className={styles.downloadBtn}
                            style={{right: isRTL ? '5px' : '', left: isRTL ? '' : '5px'}}
                            src="/images/pdf/downloadIcon2.svg" alt=""
                            onClick={() => setShowButton(prevState => !prevState)}
                        />
                    }

                </button>
            </a>
            {/* <div>*/}
            {/*     <div className={styles.bookPrint} id="book" ref={pdfref}>*/}
            {/*         <div className={styles.bookCover}>*/}
            {/*             /!*<img className={styles.profileImage} src={myBook?.profile?.ProfileImage} alt=""/>*!/*/}
            {/*             /!*{myBook?.profile?.ProfileImage &&*!/*/}
            {/*             {myBook?.profile?.ProfileImage.trim() ?*/}
            {/*                 <div className={styles.profileImage}>*/}
            {/*                     <Image*/}
            {/*                         src={myBook?.profile?.ProfileImage}*/}
            {/*                         alt="image"*/}
            {/*                         layout='fill'*/}
            {/*                         objectFit='cover'*/}
            {/*                         priority*/}
            {/*                     />*/}
            {/*                 </div>*/}

            {/*                 :*/}
            {/*                 <img className={styles.profileImage} src="/images/table/profile.png" alt=""/>*/}
            {/*             }*/}

            {/*             /!*}*!/*/}

            {/*             <div className={styles.userInfo}>*/}
            {/*                 <p className={`${styles.name} ${styles.farsi}`}>*/}
            {/*                     {myBook?.profile?.FullName}*/}
            {/*                 </p>*/}
            {/*                 <p className={`${styles.words} ${styles.farsi}`}>*/}
            {/*                     پس از*/}
            {/*                     {" " + myBook?.profile?.ContestProfile?.DaysPlayed + " "}*/}
            {/*                     روز بازی در دنیای واژه‌ها*/}
            {/*                     {" " + myBook?.words?.memorized?.length + " "}*/}
            {/*                     واژه آموختم*/}
            {/*                 </p>*/}
            {/*                 <div className={`${styles.medalsWrapper} ${styles.farsi}`}>*/}
            {/*                     <p>*/}
            {/*                         {myBook?.profile?.ContestProfile?.TotalGoldBadges}*/}
            {/*                     </p>*/}
            {/*                     <p>*/}
            {/*                         {myBook?.profile?.ContestProfile?.TotalSilverBadges}*/}
            {/*                     </p>*/}
            {/*                     <p>*/}
            {/*                         {myBook?.profile?.ContestProfile?.TotalBronzeBadges}*/}
            {/*                     </p>*/}
            {/*                     <p>*/}
            {/*                         {myBook?.profile?.ContestProfile?.DiamondBadges}*/}
            {/*                     </p>*/}
            {/*                 </div>*/}
            {/*             </div>*/}
            {/*         </div>*/}
            {/*         <div className="pagebreak"/>*/}
            {/*         <div className={styles.prePageMemo}>*/}
            {/*             <p className={styles.prePageMemoWordCount}>*/}
            {/*                 تعداد*/}
            {/*                 {" " + myBook?.words?.memorized?.length}*/}
            {/*             </p>*/}
            {/*         </div>*/}
            {/*         {memorizedWords()}*/}
            {/*         /!*{getWords("slipper")}*!/*/}
            {/*         <div className="pagebreak"/>*/}
            {/*         <div className={styles.prePageSlippery}>*/}
            {/*             <p className={styles.prePageMemoWordCount}>تعداد{" " + myBook?.words?.slipper?.length}</p>*/}
            {/*         </div>*/}
            {/*         {slipperyWords()}*/}
            {/*         <div className="pagebreak"/>*/}
            {/*         <div className={styles.prePageNewWords}>*/}
            {/*             <p className={styles.prePageMemoWordCount}>تعداد{" " + myBook?.words?.new?.length}</p>*/}
            {/*         </div>*/}
            {/*         {newWords()}*/}
            {/*         <div className="pagebreak"/>*/}
            {/*         <div className={styles.certificate}>*/}
            {/*             <p className={styles.userName}>{myBook?.profile?.FullName}</p>*/}
            {/*             <p className={styles.daysPlayed}>{myBook?.profile?.ContestProfile?.DaysPlayed}</p>*/}
            {/*             <p className={styles.learntWords}>{myBook?.words?.memorized?.length}</p>*/}
            {/*             <p className={styles.totalPlayers}>{myBook?.totalPlayers}</p>*/}
            {/*         </div>*/}
            {/*         <div className="pagebreak"/>*/}
            {/*         <div className={styles.bookCoverEnd}/>*/}
            {/*         /!*<img className={styles.bookCoverEnd} src="/images/pdf/bookCoverEnd.svg" alt=""/>*!/*/}
            {/*     </div>*/}
            {/*</div>*/}
        </div>
    );
};

export default MyWordsBook;